import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1 11.993c.018.993.063 1.821.136 2.484a2.504 2.504 0 0 0 2.211 2.217c.21.024.425.045.646.066v1.73a1.498 1.498 0 0 0 2.552 1.072l2.613-2.575c.247.002.497.003.752.003 2.62 0 4.861-.1 6.728-.302a2.504 2.504 0 0 0 2.217-2.22c.096-.874.143-2.032.143-3.478a43.8 43.8 0 0 0-.126-3.563 3.506 3.506 0 0 0-3.181-3.207A64.717 64.717 0 0 0 11.995 4v1.004c1.207.038 2.41.11 3.607.215a2.504 2.504 0 0 1 2.272 2.29c.082.987.123 2.147.123 3.481 0 1.413-.046 2.537-.137 3.369a1.502 1.502 0 0 1-1.33 1.331c-1.828.198-4.035.297-6.621.297-.323 0-.64-.001-.95-.004a.5.5 0 0 0-.355.143l-2.761 2.721a.5.5 0 0 1-.85-.358V16.3a.5.5 0 0 0-.46-.499c-.375-.03-.734-.065-1.077-.103a1.503 1.503 0 0 1-1.327-1.33A26.794 26.794 0 0 1 2 11.993H1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.396 19.014h1.6c.288 0 .572-.001.854-.004l2.597 2.558a1.498 1.498 0 0 0 2.122-.018c.275-.281.43-.66.43-1.055v-1.729c.22-.02.436-.042.645-.065a2.504 2.504 0 0 0 2.212-2.218c.096-.875.144-2.036.144-3.487a44 44 0 0 0-.126-3.567 3.51 3.51 0 0 0-2.213-2.978.502.502 0 0 0-.364.934 2.508 2.508 0 0 1 1.58 2.128c.082.987.123 2.148.123 3.483 0 1.417-.047 2.544-.139 3.377a1.503 1.503 0 0 1-1.326 1.33c-.343.038-.702.073-1.078.104a.501.501 0 0 0-.459.5v2.188a.5.5 0 0 1-.85.358l-2.745-2.705a.5.5 0 0 0-.357-.143c-.345.004-.695.006-1.05.006h-1.6a971.111 971.111 0 0 0-2.902 0 .5.5 0 0 0 .002 1.003h2.9Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 7a5 5 0 1 1 10 0A5 5 0 0 1 1 7Zm.5 0a4.48 4.48 0 0 0 1.144 2.998c.001.001 6.36-6.349 6.359-6.35A4.5 4.5 0 0 0 1.5 7Zm4.503 4.498A4.5 4.5 0 0 0 9.359 4c-.001-.001-6.36 6.349-6.359 6.35a4.483 4.483 0 0 0 3.003 1.148Z",
    fill: "#FF5C39",
    stroke: "#FF5C39",
    strokeWidth: 0.4
  }));
};

var SvgMessageDisabled = styled(SvgComponent).withConfig({
  displayName: "MessageDisabled__SvgMessageDisabled",
  componentId: "sc-1yeo1ia-0"
})(["", " ", ""], size, color);
export default SvgMessageDisabled;